// ProductDetail.js

import React, {Component} from 'react';
import { Button, Form , Table , Container, Row, Col ,  ButtonToolbar, Overlay, Popover } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';
const ProductLocals = ["Eng", "Kor", "Jpn", "Chn", "Esp", "Fra"];

export default class ProductDetail extends Component {
    static defaultProps = {
        item: null,
        images : null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.timer = null;
        this.locals = ProductLocals;
        this.emptydetail = { TITLE :  '' 
        , TIMAGE : '' ,  LANG : '' 
        , PRODUCTION : '' , ARTIST : '' 
        , CONTENT : ''
        , CATEGORY : ''   
         }

        this.state = {
            answervisible : false,
            enable : true,
            item : this.props.item,
            images : this.props.images,
            language : this.locals[0],
            details : [], 
            detail: this.emptydetail
        };
    }
        
    componentWillReceiveProps(nextProps){
        console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState( { item : nextProps.item ,  images : nextProps.images } );
        this.refreshGetInfo();
    }

    refreshGetInfo() {
        if ( this.timer )
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.handleGetInfo(null);
        }, 500);
    }

    handleDetail() {
        this.setState({answervisible: true });
    }

    handleClose() {
        this.setState({answervisible: false });
    }

    handleGetInfo(event) {
        Config.fetchData('productdetails' , {
            PCODE : this.state.item.PCODE
        }, (result, count) => {
            console.log('productdetails=', result);
            this.setState({details : result} , () => {
                this.handleChangeDetail( this.state.language );
            })            
        }, true);         
    }

    handleChangeDetail(lang) {
        const result = this.state.details.filter( (data)=>{ return data.LANG == lang } )
        if( result.length > 0 ) 
            this.setState( { detail: result[0] });
        else
            this.setState( { detail: this.emptydetail });
    }

    handleChangeLanguage(event) {
        this.setState({ language: event.target.value } , () => {
            this.handleChangeDetail( this.state.language );
        });
    }

    handleChangeTITLE(event) {
        var item = this.state.detail;
        item.TITLE = event.target.value;
        this.setState({ detail: item });
    }

    handleChangeTIMAGE(event) {
        var item = this.state.detail;
        item.TIMAGE = event.target.value;
        this.setState({ detail: item });
    }

    handleChangeNOTE(event) {
        var item = this.state.detail;
        item.CONTENT = event.target.value;
        this.setState({ detail: item });
    }

    handleChangePRODUCTION(event) {
        var item = this.state.detail;
        item.PRODUCTION = event.target.value;
        this.setState({ detail: item });
    }
 
    handleChangeARTIST(event) {
        var item = this.state.detail;
        item.ARTIST = event.target.value;
        this.setState({ detail: item });
    }
 
    handleChangeCATEGORY(event) {
        var item = this.state.detail;
        item.CATEGORY = event.target.value;
        this.setState({ detail: item });
    }   
    
    handleSubmit(event) {

        Config.fetchData('insproductdetail' , {
                PCODE: this.state.item.PCODE,
                LANG: this.state.language,
                TITLE : this.state.detail.TITLE,
                TIMAGE : this.state.detail.TIMAGE,
                PRODUCTION : this.state.detail.PRODUCTION,
                ARTIST : this.state.detail.ARTIST,
                CONTENT : this.state.detail.CONTENT,
                CATEGORY : this.state.detail.CATEGORY,  
            }, (result, count) => {
                console.log('insproductdetail=', count);

            }, true);    

            event.preventDefault();
    }

    render(){
        return (
            <div className="box" >
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-12">
                    <Button variant="primary" onClick={this.handleSubmit.bind(this)}>저장</Button>
                    {/* <Button variant="primary" onClick={this.handleRemove.bind(this)}>삭제</Button> */}
                    </div>
                </div>
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-6">
                        <Form.Group as={Col}  controlId="exampleForm.ControlInput1">
                            <Form.Label>상품코드</Form.Label>
                            <Form.Control type="title" placeholder="코드를 입력하세요." value={this.state.item.PCODE}  />
                        </Form.Group>
                    </div>
                    <div className="col-md-6">
                        <Form.Group as={Col}  controlId="exampleForm.ControlSelect1">
                            <Form.Label>언어선택</Form.Label>
                            <Form.Control as="select" value={this.state.language} onChange={this.handleChangeLanguage.bind(this)}>
                            { this.locals.map((item, index) =>
                                <option>{item}</option>
                            )}
                            </Form.Control>
                        </Form.Group>
                    </div>
                </div>
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-12">
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Label>상품 타이틀</Form.Label>
                            <Form.Control as="textarea" placeholder="타이틀을 입력하세요." rows="2" value={this.state.detail.TITLE} onChange={this.handleChangeTITLE.bind(this)}/>
                        </Form.Group>
                    </div>
                </div>    
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-6">
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Label>상품 이미지</Form.Label>
                            <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.detail.TIMAGE} onChange={this.handleChangeTIMAGE.bind(this)} />
                            <Form.Control as="select" value={this.state.detail.TIMAGE} onChange={this.handleChangeTIMAGE.bind(this)} onClick={this.handleChangeTIMAGE.bind(this)}>
                                { this.state.images.map((item, index) =>
                                    <option>{item.name}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Label>CATEGORY</Form.Label>
                            <Form.Control type="title" placeholder="입력하세요." value={this.state.detail.CATEGORY} onChange={this.handleChangeCATEGORY.bind(this)} />
                        </Form.Group>
                    </div>
                    <div className="col-md-6">
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Label>프로덕션</Form.Label>
                            <Form.Control type="title" placeholder="입력하세요." value={this.state.detail.PRODUCTION} onChange={this.handleChangePRODUCTION.bind(this)} />
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Label>아티스트</Form.Label>
                            <Form.Control type="title" placeholder="입력하세요." value={this.state.detail.ARTIST} onChange={this.handleChangeARTIST.bind(this)} />
                        </Form.Group>
                    </div>
                </div>
                <div className="row" style={{  margin: 10 }}>
                    <div className="col-md-12">
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>내용</Form.Label>
                            <Form.Control as="textarea" rows="10" value={this.state.detail.CONTENT} onChange={this.handleChangeNOTE.bind(this)}/>
                        </Form.Group>
                    </div>
                </div>
 
            </div>

        );
    }
};





// WEBPACK FOOTER //
// src/components/ProductDetail.js